import React, { useState } from "react";
import {
  LogOut,
  LogIn,
  ChevronDown,
  UserCircle,
} from "lucide-react";

const Header = ({ user, onLogout, onLogin }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <header className="w-full bg-white/10 backdrop-blur-xl border-b border-white/30 shadow-xl px-6 py-2 flex justify-end items-center relative z-50">
      {user ? (
        <div className="relative">
          <button
            onClick={() => setShowDropdown((prev) => !prev)}
            className="flex items-center gap-2 text-white hover:bg-black/20 px-3 py-2 rounded-xl transition"
          >
            <img
  src={user.avatar || `https://ui-avatars.com/api/?name=${user.name}`}
  alt="Avatar"
  className="w-8 h-8 rounded-full object-cover"
/>

            <span className="font-medium text-[#d97925] text-xl">{user.name || "User"}</span>


            <ChevronDown size={18} />
          </button>

          {showDropdown && (
            <div className="absolute right-0 mt-2 w-52 bg-white/10 backdrop-blur-xl border border-white/30 shadow-2xl rounded-xl py-2 text-white">
              <button className="w-full flex items-center gap-3 px-4 py-2 hover:bg-[#d97925] transition">
                <UserCircle size={18} />
                Edit Profile
              </button>
              <button
                onClick={onLogout}
                className="w-full flex items-center gap-3 px-4 py-2 hover:bg-[#d97925] transition"
              >
                <LogOut size={18} />
                Logout
              </button>
            </div>
          )}
        </div>
      ) : (
        <button
          onClick={onLogin}
          className="flex items-center gap-2 bg-[#d97925] text-white px-4 py-2 rounded-xl shadow hover:scale-105 transition"
        >
          <LogIn size={18} />
          Login
        </button>
      )}
    </header>
  );
};

export default Header;
